    import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Work Status List with Query (for remote operations)
export const getWorkStatusListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WORK_STATUSES}?${stringifyParams(
			params
		)}`
	);
};

// Get Work Status List with Query
export const getWorkStatusList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
        // populate: ['creation_user', 'modification_user'],
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WORK_STATUSES}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Work Status
export const getWorkStatus = work_status_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WORK_STATUS}${work_status_id}`
	);
};

// Add New Work Status
export const addNewWorkStatusApi = work_status => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_WORK_STATUS}`,
		work_status
	);
};

// Update Work Status
export const updateWorkStatusApi = work_status => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_WORK_STATUS}${work_status._id}`,
		work_status
	);
};

// Delete Work Status
export const deleteWorkStatusApi = work_status_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_WORK_STATUS}${work_status_id}`
	);
};

// Check if Work Status Exists
export const checkWorkStatusExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_WORK_STATUS_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
